import { FunctionComponent, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import styled, { CSSProperties } from 'styled-components';
import { mediaScreen } from '../../utils/mediaScreen';
import { Icon } from '../ui/icon';

export const PromoBanner: FunctionComponent<IPromoBanner> = ({
  style,
  href,
  title,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [cookies, setCookie] = useCookies([COOKIE_KEY]);

  function isDismissed() {
    return cookies[COOKIE_KEY] === 'dismissed';
  }

  function dismiss() {
    setCookie(COOKIE_KEY, 'dismissed', { path: '/' });
  }

  useEffect(() => {
    setIsVisible(!isDismissed());
  }, [isDismissed()]);

  if (!isVisible || !title) {
    return null;
  }

  return (
    <Container
      id="promo-banner"
      style={style}
      onClick={() => {
        if (href) {
          window.open(href, '_blank');
        }

        dismiss();
      }}
    >
      <span>{title}</span>

      <div
        className="close"
        onClick={(e) => {
          e.stopPropagation();
          dismiss();
        }}
      >
        <Icon name="close" size={14} />
      </div>
    </Container>
  );
};

const COOKIE_KEY = 'promo-banner';

const Container = styled.div`
  background: ${(props) => props.theme.colors.eb1};
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  color: white;
  font-size: 16px;
  padding: 0 50px;
  text-align: center;
  margin-top: -16px;
  margin-bottom: 16px;

  :hover {
    cursor: pointer;
    background: #3c30ab;
  }

  .close {
    position: absolute;
    height: 48px;
    width: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    right: 0;

    &:hover {
      background: #2f2583;
    }
  }

  ${mediaScreen('xs', 'md')} {
    font-size: 13px;
  }
`;

interface IPromoBanner {
  style?: CSSProperties;
  title?: string;
  href?: string;
}
